export default __webpack_public_path__ + "static/media/client-list.43d32f0e.svg";